/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createTyped } from '../../factoriesNumber.js';
export var typedDependencies = {
  createTyped
};